import { rpc } from './rpc.js';
export default {
    rpc,
    types: {
        // StorageKey extends Bytes
        PrefixedStorageKey: 'StorageKey'
    }
};
